import React, { useEffect } from 'react';

import { SlNavBarPositions, SlNavbarThemes, SlNavbarType } from '../../../features/shared/public/globalInterfaces/globalInterfaces';
import { SlNavbarState } from '../../../features/navigation/private/global-interface';
import { SlFooter } from '../../../features/navigation/public/SlFooter/SlFooter';
import { SlHelmet } from '../../../features/shared/public/SlHelmet/SlHelmet';
import { setNavigationConfigs } from '../../utils/navigationManager';
import { SlTeams } from '../../../features/staticPages/public/SlTeams/SlTeams';

export const Teams = () => {
	useEffect(() => {
		setNavigationConfigs({
			state: SlNavbarState.shown,
			theme: SlNavbarThemes.light,
			position: SlNavBarPositions.relative,
			type: SlNavbarType.teams,
		});

		return () => {
			setNavigationConfigs({
				state: SlNavbarState.hidden,
				type: SlNavbarType.default,
			});
		};
	}, []);

	return (
		<>
			<SlHelmet
				title="Interactive Tech & Coding Courses for Businesses | Sololearn Teams"
				description="Corporate training has changed! Upskill your company’s employees in tomorrow’s tech with Sololearn: the fast, fun, online learning and development platform that strengthens teams."
			/>
			<SlTeams />
			<SlFooter />
		</>
	);
};
